import {ElMessage} from "element-plus";
import i18n from "@/i18n";
import {getLocalOrRemoteUserInfo, getUserInfo, login} from "@/utils/FPUser";


export async function checkoutLogin(to, from, next) {
    try {
        let userInfo = await getLocalOrRemoteUserInfo();
        if (userInfo == null) {
            ElMessage.error(i18n.global.t('console.log_in'))
            window.location.href = '/user/login';
            return next('/user/login');
        }
        return next();
    } catch (e) {
        console.log("检查是否登录失败:", e)
        ElMessage.error(i18n.global.t('console.log_in'))
        window.location.href = '/user/login';
        return next('/user/login')
    }
}

export async function checkoutAdmin(to, from, next) {
    try {
        let userInfo = await getLocalOrRemoteUserInfo(); 
        if (userInfo != null && userInfo.role === 1) {
            next();
        } else {
            let user = await getUserInfo();
            let tokenStr = await login(user, null);
            localStorage.setItem('token', tokenStr);
            let userInfo = await getLocalOrRemoteUserInfo(); 
            if (userInfo!= null && userInfo.role === 1) {
                next()
            } else {
                ElMessage.error(i18n.global.t('console.no_permission'));
                next('/');
            }
            
        }
    } catch (e) {
        console.log("检查是否管理员失败:", e)
        ElMessage.error(i18n.global.t('console.no_permission'));
        next('/'); 
    }
}